import React from "react";
import "./styles.sass";

import {
  CustomBadges,
  CustomIcon,
  CustomSubLogin,
  TableNullData,
  UserInformation,
} from "../../../../components";
import Context from "../../../../context";
import Cookies from "js-cookie";
import values from "../../../../values";
import utils from "../../../../utils";
import constants from "../../../../values/constants";
import DropDownLoading from "../../../../components/DropDownLoading";
import { useTranslation } from "react-i18next";

type Props = {
  data: any[];
};

const Body = ({ data }: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const { setShowModal, setSelectedCompany } = React.useContext(Context.CompanyScreen);

  const userType: string = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));
  const writePermission: string | undefined = Cookies.get(
    constants.USER.WRITE_PERMISSION
  )?.toString();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickCompany(company: any): void {
    setSelectedCompany(company);
    setShowModal("SHOW_COMPANY_INFORMATION");
  }

  function onClickManager(company: any): void {
    setSelectedCompany(company);
    setShowModal("SHOW_MANAGER_INFORMATION");
  }

  function onClickSuperAgent(company: any): void {
    setSelectedCompany(company);
    setShowModal("SHOW_SUPERAGENT_INFORMATION");
  }

  function onUpdate(company: any): void {
    setSelectedCompany(company);
    setShowModal("UPDATE");
  }

  function onDelete(company: any): void {
    setSelectedCompany(company);
    setShowModal("DELETE");
  }

  function onClickFavorite(company: any): void {
    setSelectedCompany(company);
    setShowModal("FAVORITE");
  }

  function onApprove(company: any): void {
    setSelectedCompany(company);
    setShowModal("APPROVE");
  }

  function onDocumentsApprove(company: any): void {
    setSelectedCompany(company);
    setShowModal("APPROVE_DOCUMENTS");
  }

  function onPayCompanyDeposit(company: any): void {
    setSelectedCompany(company);
    setShowModal("PAY_COMPANY_DEPOSITE");
  }

  function onClickShowDrivers(company: any): void {
    setSelectedCompany(company);
    setShowModal('SHOW_DRIVERS');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (data?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="company-table-body-container">
      {data?.map((company: any, index: number) => {
        return (
          <tr key={`company-${index}`}>
            <td className="pointer" onClick={() => onClickCompany(company)}>
              <UserInformation
                name={company?.companyInformation?.companyName}
                avatar={company?.avatar}
                phoneNumber={company?.companyInformation?.address}
              />
            </td>
            <td className="pointer" onClick={() => onClickManager(company)}>
              <UserInformation
                avatar={company?.avatar}
                name={company?.firstName}
                lastName={company?.lastName}
                phoneNumber={company?.phoneNumber}
                hideAvatar
              />
            </td>
            {userType === "ADMIN" && (
              <td className="pointer" onClick={() => onClickSuperAgent(company)}>
                <UserInformation
                  name={company?.companyInformation?.superAgent?.firstName}
                  lastName={company?.companyInformation?.superAgent?.lastName}
                  phoneNumber={company?.companyInformation?.superAgent?.phoneNumber}
                  hideAvatar
                />
              </td>
            )}

            <td>
              <CustomBadges
                title={company?.companyInformation?.approved?.isApproved ? t("approved") : t("disApproved")}
                type ={company?.companyInformation?.approved?.isApproved ? "success" : "danger"            }
              />
            </td>
            <td>
              <div className='tbody'>
                <CustomBadges
                  type={
                    company?.companyInformation?.documents?.approve === undefined
                      ? "warning" : company?.companyInformation?.documents?.approve === false
                        ? "danger"  : "success"
                  }
                  title={
                    company?.companyInformation?.documents?.approve === undefined
                      ? t("DocumentsNotUploaded") : company?.companyInformation?.documents?.approve === false
                       ? t("DocumentsNotApproved") : t("DocumentsApproved")
                  }
                />
                {userType === "ADMIN" &&
                  !company?.companyInformation?.documents?.approve &&
                  company?.companyInformation?.documents?.approve !==
                    undefined && (
                    <CustomIcon
                      icon="fas fa-file-check"
                      hoverTitle={t("approveDocuments")}
                      onClick={() => onDocumentsApprove(company)}
                    />
                  )}
              </div>
            </td>
            <td>
              {`${utils.convertNumberToPrice(company?.wallet?.deptAdmin2Company)} تومان `}
            </td>
            <td>
              {`${utils.convertNumberToPrice(company?.wallet?.deptCompany2Admin)} تومان `}
            </td>
            <td className='last-child-tbody'>
              {writePermission === "true" && (
                <div className='tbody'>
                  {/*isAdminPozMachine*/}
                  {(userType === 'ADMIN' || userType === 'COMPANY') &&
                    !company?.companyInformation?.approved?.isApproved && (
                      <CustomIcon icon="fas fa-check" hoverTitle="تأیید" onClick={() => onApprove(company)}/>
                    )
                  }
                  {
                    company.companyInformation.isAdminPozMachine === false && (
                      <CustomIcon
                        icon="fas fa-envelope-open-dollar"
                        hoverTitle={'تسویه حساب ادمین'}
                        onClick={() => onPayCompanyDeposit(company)}
                      />
                    )
                  }
                  <CustomIcon
                    icon="fas fa-credit-card"
                    hoverTitle={'تسویه حساب شرکت'}
                    onClick={() => onPayCompanyDeposit(company)}
                  />
                  <CustomIcon icon="fas fa-pen" hoverTitle="ویرایش" onClick={() => onUpdate(company)}/>
                  {userType === 'ADMIN' && (
                    <>
                      <CustomSubLogin userId={company._id}/>
                      <CustomIcon icon="fas fa-trash" hoverTitle='حذف' onClick={() => onDelete(company)}/>
                    </>
                  )}
                  {userType === 'ADMIN' && (
                    <>
                      <CustomIcon
                        hoverTitle='لیست رانندگان'
                        icon='fa-solid fa-users'
                        onClick={() => onClickShowDrivers(company)}
                      />
                      <CustomIcon
                        icon={company?.companyInformation?.isFavorite ? 'fa-solid fa-star' : 'fa-regular fa-star'}
                        hoverTitle='مورد علاقه'
                        onClick={() => onClickFavorite(company)}
                      />
                    </>
                  )}
                </div>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Body;
